import { Injectable, TemplateRef, Type } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable({ providedIn: 'root' })
export class CustomModalService extends BsModalService {

  override show<T>(
    content: string | TemplateRef<any> | { new (...args: any[]): T },
    config?: ModalOptions<T>
  ): BsModalRef<T> {
    const defaultClass = 'modal fade in custom-modal-fix';
    const passedClass = config?.class ?? '';
    const mergedClass = `${defaultClass} ${passedClass}`.trim();
    const mergedConfig: ModalOptions<T> = {
      ...config,
      class: mergedClass,
    };
    return super.show(content, mergedConfig);
  }
}